<template>
    <div
        class="ds-product-card ds-product-card--portrait"
        :class="[
            card.isOnline ? 'ds-product-card--eticket' : 'ds-product-card--ticket',
            { authenticated: card.hideForNotLoggedUsers },
        ]"
    >
        <div class="ds-product-card__inner">
            <div
                v-html="
                    WebpHelper.createPictureTag(card.teaserImageUrl, `${card.name} - obrázek`, 'ds-product-card__img')
                "
            ></div>
            <em class="ds-product-card__gradient"></em>
            <div
                v-if="card.isOnline"
                class="ds-product-card-tag ds-product-card-tag--add-favorites ds-product-card__left-placeholder authenticated"
            >
                <!-- Top left slot -->
                <button
                    class="ds-product-card-tag__button ds-product-card-tag__button--add-favorites"
                    :class="{ 'ds-product-card-tag__button--active': isFavorite }"
                    data-js-hook="ds-product-card-add-favorites"
                >
                    <DsIcon @click="toggleFavorite" name="favorite-star-active" :width="16" :height="16" />
                </button>
            </div>

            <div class="ds-product-card-tag ds-product-card-tag--scratch ds-product-card__right-placeholder">
                <!-- Top right slot -->
                <img
                    class="ds-product-card-tag__img"
                    src="/frontend/web/img/scrappers/scratch.svg"
                    height="39"
                    width="60"
                    alt=""
                />
                <span class="ds-product-card-tag__wrapper ds-product-card-tag__text"
                    >{{ card.roundPrice }}&nbsp;<span class="ds-product-card-tag__currency">Kč</span></span
                >
            </div>

            <div class="ds-product-card__text-wrap">
                <h3 class="ds-product-card__title" v-html="card.name"></h3>
                <span class="ds-product-card__sub-text" v-html="card.teaserText"></span>
                <span class="ds-product-card__price" v-html="prizeText"></span>
            </div>

            <a
                :href="card.pageUrl.relative"
                class="ds-product-card__link"
                :class="{ 'game-launcher': card.isOnline }"
                :data-game-id="card.externalSystemID"
                :data-game-code="card.codeName"
                :data-price="card.roundPrice"
                :data-prize="card.prizeFilter ? card.prizeFilter : card.prize"
                :data-transparent="card.isTransparent"
            >
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
import { TicketPromoCard } from "@/tickets/models/ticket-promo-card";
import { WebpHelper } from "@sazka/utils/webp-helper";
import { StringUtils } from "@sazka/utils/string-utils";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { computed } from "vue";
import { useFavoriteTicketsStore } from "../favorite-tickets-store";

const props = defineProps<{
    card: TicketPromoCard;
}>();

const store = useFavoriteTicketsStore();
const isFavorite = computed(() => store.isFavoriteTicket(props.card.externalSystemID));
const toggleFavorite = () => store.toggleFavoriteTicket(props.card.externalSystemID);

const prizeText = computed(() =>
    props.card.teaserPriceText ? props.card.teaserPriceText : StringUtils.formatCurrency(props.card.prize)
);
</script>
